<template>
  <div class='body-box marginBox'>
    <el-row class='plan'>
      <el-col :span='24'>
        <el-tabs v-model='activeName' @tab-click='btnStatus'>
          <el-tab-pane label='待确定' name='CONFIRM'></el-tab-pane>
          <el-tab-pane label='待出行' name='TRAVEL'></el-tab-pane>
          <el-tab-pane label='已取消' name='CANCEL'></el-tab-pane>
          <el-tab-pane label='已完成' name='END'></el-tab-pane>
          <el-tab-pane label='全部' name='ALL'></el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span='5'>
        <search-input v-model='queryInfo.keyword' @change='handleQuery' />
      </el-col>
    </el-row>

    <el-table :height="'calc(100% - 120px)'" :data='orderList' class='button-box'>
      <el-table-column label='比赛名称' prop='name' />
      <el-table-column label='比赛球场' prop='courtName' />
      <el-table-column label='比赛日期' prop='raceDate'>
        <template slot-scope='scope'>
          {{ scope.row.raceDate | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label='开始时间(至)' prop='raceTime'></el-table-column>
      <el-table-column label='确定日期' prop='confirmRaceData'>
        <template slot-scope='scope'>{{ scope.row.confirmRaceData | formatDate }}</template>
      </el-table-column>
      <el-table-column label='确定时间' prop='confirmRaceEndTime'></el-table-column>
      <el-table-column label='确定球场' prop='finalCourse'></el-table-column>
      <el-table-column label='组数' prop='num'></el-table-column>
      <el-table-column label='开球方式' prop='kickOffMode'>
        <template slot-scope='scope'>
          {{ scope.row.kickOffMode | kickOffMode }}
        </template>
      </el-table-column>
      <el-table-column label='远距奖' prop='distanceAward'></el-table-column>
      <el-table-column label='近洞奖' prop='nearHoleAward'></el-table-column>
      <el-table-column label='打球方式' prop='record'>
        <template slot-scope='scope'>
          {{ scope.row.record | record }}
        </template>
      </el-table-column>
      <el-table-column label='成绩表' prop='gradeTable'>
        <template slot-scope='scope'>
          {{ scope.row.gradeTable | gradeTable }}
        </template>
      </el-table-column>
      <el-table-column label='食物' prop='food'>
        <template slot-scope='scope'>
          {{ scope.row.food | food }}
        </template>
      </el-table-column>
      <el-table-column label='巴士' prop='bus'>
        <template slot-scope='scope'>
          {{ scope.row.bus | formatYESNo }}
        </template>
      </el-table-column>
      <el-table-column label='奖项设置' prop='prize'>
        <template slot-scope='scope'>
          {{ scope.row.prize | formatYESNo }}
        </template>
      </el-table-column>
      <el-table-column label='预约人数' prop='personNum'></el-table-column>
      <el-table-column label='预约分组'>
        <template slot-scope='scope'>
          <el-button @click='lookDiamond(scope.row.groupPerson)'>查看</el-button>
        </template>
      </el-table-column>
      <el-table-column label='预约人' prop='userName'></el-table-column>
      <el-table-column label='发放确认书' prop='confirmation'>
        <template slot-scope='scope'>
          {{ scope.row.confirmation | formatConfirmation }}
        </template>
      </el-table-column>
      <el-table-column label='操作' min-width='100' fixed='right'>
        <template slot-scope='scope'>
          <el-popover placement='right' trigger='click'>
            <div class='foldBtnBox'>
              <div>
                <el-button @click='decidedOrder(scope.row)'>发送确认书</el-button>
              </div>
              <div>
                <el-button @click='getUserInfoByOrder(scope.row)'>查看下单用户信息</el-button>
              </div>
              <div>
                <el-button @click='updateIntegrated(scope.row)'>待积分</el-button>
              </div>
              <div>
                <el-button @click='updateGameOrder(scope.row)'>修改</el-button>
              </div>
              <div>
                <el-button @click='openPlayTime(scope.row)'>修改最终确认信息</el-button>
              </div>
              <div>
                <el-button @click='openOrder(scope.row)'>修改状态</el-button>
              </div>
              <div>
                <el-button @click='removeById(scope.row.id)'>删除</el-button>
              </div>
            </div>
            <el-button slot='reference'>更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <div class='fixedBox'>
      <pagination ref='page' :query-param.sync='queryInfo' @pagination='getOrderList'></pagination>
    </div>


    <!--查看打球人-->
    <el-dialog title='查看打球人' :visible.sync='dialogVisible' width='30%'>
      <div v-for='(item, index) in valList' :key='index' class='plo'>
        <span>第{{ item.type }}组  :  </span>
        <span v-for='(item2, i) in item.data' :key='item2.id'><span v-if='i !== 0'> , </span> {{ item2.name }} </span>
      </div>
    </el-dialog>
    <!--获取用户信息-->
    <user-info ref='getUserInfo'></user-info>
    <!--修改状态-->
    <modify-order @refresh-list='getOrderList' ref='modifyOrder'></modify-order>

    <!--发放积分-->
    <order-integral @refresh-list='getOrderList' ref='orderIntegral'></order-integral>

    <el-dialog title='修改最终确认信息' :visible.sync='dialogPlayBallTime' width='30%'>
      <el-form label-width='100px' :model='playBallTime'>
        <el-form-item label='最终打球日期'>
          <el-date-picker v-model='playBallTime.confirmRaceData' type='date' value-format='yyyy-MM-dd'
                          placeholder='选择日期' style='width: 100%;'></el-date-picker>
        </el-form-item>

        <el-form-item label='最终打球时间'>
          <el-input type='textarea' autosize v-model='playBallTime.confirmRaceEndTime'></el-input>
        </el-form-item>

        <el-form-item label='最终确认球场'>
          <el-input type='textarea' autosize v-model='playBallTime.finalCourse'></el-input>
        </el-form-item>
      </el-form>

      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogPlayBallTime = false'>取 消</el-button>
        <el-button type='primary' @click='modifyStadiumOrder'>确 定</el-button>
      </span>
    </el-dialog>
    <!--发送邮件-->
    <send-race-mail ref='sendmail' @refresh-list='handleQuery'></send-race-mail>
  </div>
</template>

<script>
import { deleteRacesById, getRacesList } from '@/api/race/race'
import Pagination from '@/components/common/Pagination/index'
import OrderIntegral from '@/components/common/orderIntegral/orderIntegral'
import ModifyOrder from '@/components/common/modifyOrder/index'
import { modifyRacesOrderById } from '@/api/order/order'
import { getData } from '@/utils/code'
import UserInfo from '@/components/common/user/userInfo'
import SearchInput from '@/components/common/searchInput/searchInput'
import sendRaceMail from '@/components/common/sendRaceMail/sendRaceMail'

export default {
  components: { SearchInput, Pagination, OrderIntegral, ModifyOrder, UserInfo, sendRaceMail },
  data() {
    return {
      activeName: 'CONFIRM',
      orderList: [],
      dialogVisible: false,
      dialogPlayBallTime: false,
      playBallTime: {},
      valList: [],
      queryInfo: {
        status: 'CONFIRM'
      }
    }
  },
  created() {

  },
  mounted() {
    this.handleQuery()
  },
  methods: {
    openPlayTime(row) {
      this.dialogPlayBallTime = true
      this.playBallTime = JSON.parse(JSON.stringify(row))
    },

    modifyStadiumOrder() {
      const { confirmRaceData, confirmRaceEndTime, finalCourse } = this.playBallTime
      let data = {
        confirmRaceData,
        confirmRaceEndTime,
        finalCourse
      }
      modifyRacesOrderById(data, this.playBallTime.id).then(res => {
        let data = getData(res)
        if (data != null) {
          this.$message.success('修改成功!')
          this.dialogPlayBallTime = false
          this.handleQuery()
        }
      })
    },

    btnStatus(val) {
      this.queryInfo.status = val.name === 'ALL' ? '' : val.name
      this.handleQuery()
    },

    //确认积分弹窗
    updateIntegrated(row) {
      this.integralData = JSON.parse(JSON.stringify(row))
      this.$refs.orderIntegral.editDialog(this.integralData)
    },

    removeById(id) {
      this.$confirm('是否删除,此操作不可逆?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteRacesById(id).then(res => {
          if (res.code === '0') {
            this.$message.success('删除成功')
            this.handleQuery()
          }
        })
      }).catch(() => {
      })

    },

    //修改状态
    openOrder(row) {
      this.$refs.modifyOrder.editDialog(row, 'RACE')
    },

    //查看打球人
    lookDiamond(val) {
      this.valList = val
      this.dialogVisible = true
    },

    //获取列表
    getOrderList(page, cb) {
      getRacesList(page).then(res => {
        this.orderList = cb(res)
        this.orderList.forEach(f => {
          if (f.groupPerson) {
            f.groupPerson = JSON.parse(f.groupPerson)
          }

        })
      })
    },

    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    },
    //查看下单用户信息
    getUserInfoByOrder(row) {
      this.$refs.getUserInfo.getUserInfo(row.userInfo)
    },
    //修改比赛页面
    updateGameOrder(row) {
      localStorage.setItem(row.id, JSON.stringify(row))
      this.$router.push({
        path: '/updateGameOrder',
        query: {
          id: row.id
        }
      })
    },
    //确定订单
    decidedOrder(row) {
      this.$refs.sendmail.editDialog(row)
    }

  }
}
</script>

<style scoped>

</style>
